import React, { useEffect, useRef } from "react";
import "./Logo.css";
import { createTimeline, stagger } from "animejs";

const letters = ["B","U","1","D","L","."];

const Logo: React.FC = () => {
  return (
    <div className="logo">
      {letters.map((char, index) => {
        const fontClass =
          char === "1"
            ? "font-lovelo"
            : char === "."
            ? "font-dot"
            : "font-blanka";
        const highlightClass = char === "1" || char === "." ? "highlight" : "";

        return (
          <span
            key={index}
            className={`logo-letter ${fontClass} ${highlightClass}`}
          >
            {char}
          </span>
        );
      })}
    </div>
  );
};

export default Logo;